import { render, staticRenderFns } from "./JgpPager.vue?vue&type=template&id=2f21532a&"
import script from "./JgpPager.vue?vue&type=script&lang=js&"
export * from "./JgpPager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports